import { clarity } from 'clarity-js';
import { useEffect } from 'react';
import { Environments, Store } from 'types';

export function useClarity(store?: Store) {
  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT !== Environments.Prod) return;

    clarity.consent();
    clarity.start({
      projectId: 'dxxgc9c2qw',
      upload: 'https://m.clarity.ms/collect',
      track: true,
      content: true,
    });

    if (store) {
      const { brand, name: storeName } = store;
      clarity.identify(`${brand} - ${storeName}`);
    }

    return () => clarity.stop();
  }, [store]);
}
